import {Container, Divider, useMediaQuery} from "@material-ui/core";
import Link from "@material-ui/core/Link";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import React, {Fragment} from "react";
import {useDispatch} from "react-redux";
import {Link as RouterLink} from "react-router-dom";
import yooz_scan2pay from "assets/images/YOOZScan2Pay-Image-to-resize-and-reformat_2.png";
import yooz_agent from "assets/images/YOOZ_AGENT.png";
import yooz_online from "assets/images/YOOZ_ONLINE.png";
import yooz_payments from "assets/images/YOOZ_PAYMENTS.png";
import signUp_img from "assets/images/home_content_6.png";
import TextList from "components/public-dashboard/components/TextList";
import ContentList from "components/public-dashboard/components/contentList";
import IconHeader from "components/public-dashboard/components/iconHeader";
import {setTabPosition} from "components/public-dashboard/uiSlice";
import ContentImageBlock from "components/public-dashboard/components/contentImageBlock";
import {API_ROOT} from "constants/actionTypes";
import QuoteContainer from "../../../../shared/quote_container";
import {useParams} from "react-router";
import {reviewData} from "./constants";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({

    preserveNewLine:{
        whiteSpace: "pre-line"
    },

    inLineQuote:{
        paddingLeft: 30
    }
}));

export default function PartnersReviewContent(props) {
    const classes = useStyles();
    const theme = useTheme();
    const sm = useMediaQuery(theme.breakpoints.up("sm"));
    const xs = useMediaQuery(theme.breakpoints.down("xs"));
    const md = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();

    const params = useParams();

    const review = reviewData.find(x => x.url === params.review);


    if(!review){
        window.location.href = "/payment-gateway";
    }

    return (
        <Container>
            <ContentImageBlock
                title={""}
                titleSm="h4"
                titleLg="h3"
                titleXs="h6"
                imgPosition="left"
                img={review.logo}
                color="#1CC5FF"
                />
            <ContentList
                title="Company"
                items={[
                    <span className={classes.preserveNewLine} dangerouslySetInnerHTML={{__html: review.details.company}}>

          </span>,
                ]}
            />
            <ContentList
                title="Challenge"
                items={[
                    <span className={classes.preserveNewLine}>
                        {review.details.challenge}
                            </span>,
                ]}
            />
            <ContentList
                title="The Solution"
                items={typeof review.details.solution == 'object' ? review.details.solution.map((object) =>{

                    let val =(<div className={classes.preserveNewLine}>{object.value}</div>);
                    if(object.type == "quote")
                     val = (<QuoteContainer
                            text={object.value}
                        />)
                    return val;
                }): [
                    <span className={classes.preserveNewLine}>
                         {review.details.solution}
                       </span>,
                       <QuoteContainer
                           text={review.details.quote}
                           name={review.details.quoteTitle}
                       />
                ]}
            />
            <ContentList
                title="Impact of YOOZ"
                items={[
                    <span className={classes.preserveNewLine}>
         {review.details.impact}
          </span>,
                ]}
            />

            <Button
                color="secondary"
                variant={"contained"}
                to={"/case-studies/"}
                onClick={() => {
                    window.scrollTo(0, 0);
                }}
                component={RouterLink}
            >
                See more Partner Stories
            </Button>

        </Container>
    );
}
